module.exports = __webpack_public_path__ + "static/0080-2d3f37ce621027bdf6635dd628b26acd.png";